import { resolveApiPath } from 'client/core/appConfig';

export function getInvoiceExportDownloadLink(id: number) {
  return resolveApiPath(`invoices-export/${id}/download`);
}
